var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLangCh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "lang_ch-a",
    cx: 36,
    cy: 36,
    r: 36
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "lang_ch-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lang_ch-a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#CF142B",
    xlinkHref: "#lang_ch-a"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    fillRule: "nonzero",
    points: "43 13 29 13 29 29 13 29 13 43 29 43 29 59 43 59 43 43 59 43 59 29 43 28.999",
    mask: "url(#lang_ch-b)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 35.5,
    stroke: "#000",
    strokeOpacity: 0.2,
    mask: "url(#lang_ch-b)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLangCh);
export default __webpack_public_path__ + "static/media/lang-ch.ff7e4f7a01d1331786bb75b7116e1940.svg";
export { ForwardRef as ReactComponent };